import styled from '@emotion/styled';
import React from 'react';
import { Fonts, Spacings } from '@styles/index';
import Image from '@base/Image';
import Typography from 'aquilla/core/atoms/Typography';
import Button from 'aquilla/core/molecules/Button';
import CheckContained from 'aquilla/icons/misc/CheckContained';
import Dialog from '@comp/Dialog/Dialog';
import { appInstallInfoData } from './utils';

const Container = styled.div`
  padding: ${Spacings.SPACING_4B};
  gap: ${Spacings.SPACING_18};
`;

const Title = styled(Typography)`
  font-size: ${Fonts.H3};
  line-height: ${Spacings.SPACING_8B};
  margin-bottom: ${Spacings.SPACING_2B};
`;

const Description = styled(Typography)``;

const ImageWrapper = styled.div`
  padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_3B};
  margin-top: ${Spacings.SPACING_4B};
`;

const PhoneImage = styled(Image)`
  user-drag: none;
  user-select: none;
  object-fit: cover;
`;

const BenefitsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_0B};
  gap: ${Spacings.SPACING_3B};
`;

const BenefitsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: var(--color-text-primary);
  gap: ${Spacings.SPACING_2B};
`;

const StyledButton = styled(Button)`
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_6B};
  width: 100%;
  height: 48px;
`;

const BenefitsPoints = styled(Typography)`
  font-weight: ${Fonts.LIGHT};
`;

const AppInstallDialog = ({ isModelOpen, setIsModelOpen }) => {
  const handleDownloadApp = () => {
    window.open(
      'https://play.google.com/store/apps/details?id=com.unacademyapp'
    );
  };

  return (
    <Dialog dialogState={isModelOpen} onClose={() => setIsModelOpen(false)}>
      <Container>
        <Title variant="h3">{appInstallInfoData.title}</Title>
        <Description variant="p2" color="var(--color-text-secondary)">
          {appInstallInfoData.description}
        </Description>
        <ImageWrapper>
          <PhoneImage
            src="NewAppDownload.svg"
            height={202}
            width={272}
            alt="phone"
          />
        </ImageWrapper>
        <BenefitsWrapper>
          {appInstallInfoData?.benefits.map((item) => {
            return (
              <BenefitsContainer key={item.id}>
                <CheckContained
                  height={20}
                  width={20}
                  color="var(--color-i-blue-23)"
                />
                <BenefitsPoints variant="h6" color="var(--color-text-primary)">
                  {item}
                </BenefitsPoints>
              </BenefitsContainer>
            );
          })}
        </BenefitsWrapper>
        <StyledButton
          label={appInstallInfoData.label}
          onClick={handleDownloadApp}
          size="large"
          variant="primary"
        />
      </Container>
    </Dialog>
  );
};

export default AppInstallDialog;
